// src/pages/Products.js
import './Products.css';
import { Link } from 'react-router-dom';
import Flipbook from '../../components/FlipBook/FlipBook';

export default function Products() {
  const products = [
    {
      id: 1,
      title: 'Classic Photo Book',
      description: 'A timeless hardcover design with up to 100 pages.',
      image: '/assets/classic.png',
    },
    {
      id: 2,
      title: 'Wedding Album',
      description: 'Elegant layout for your special day with luxury finishes.',
      image: '/assets/wedding.png',
    },
    {
      id: 3,
      title: 'Baby’s First Year',
      description: 'Celebrate baby’s milestones with this adorable keepsake.',
      image: '/assets/baby3.jpg',
    },
    {
      id: 4,
      title: 'Travel Memories',
      description: 'Capture your adventures with a stylish softcover book.',
      image: '/assets/travel1.png',
    },
  ];

  const sheetTypes = [
    {
      name: 'Matte Finish',
      image: '/assets/matte.jpg',
      description: 'Soft, non-reflective pages perfect for a subtle, elegant look.'
    },
    {
      name: 'Glossy Finish',
      image: '/assets/matte.jpg',
      description: 'Vibrant and shiny sheets that enhance photo clarity and color contrast.'
    },
    {
      name: 'Lustre Finish',
      image: '/assets/matte.jpg',
      description: 'Combines the best of matte and glossy with a textured touch.'
    },
    {
      name: 'Textured Paper',
      image: '/assets/matte.jpg',
      description: 'Ideal for artistic photo books with a tactile feel and visual depth.'
    },
    {
      name: 'Silk Finish',
      image: '/assets/matte.jpg',
      description: 'Smooth, luxurious surface with a soft sheen and fingerprint resistance.'
    },
    {
      name: 'Velvet Touch',
      image: '/assets/matte.jpg',
      description: 'Premium soft-touch surface for a rich, luxurious feel in hand.'
    },
    {
      name: 'Recycled Paper',
      image: '/assets/matte.jpg',
      description: 'Eco-friendly, slightly textured option made from sustainable materials.'
    },
    {
      name: 'Pearl Finish',
      image: '/assets/matte.jpg',
      description: 'Shimmering surface that gives photos a pearlescent glow.'
    },
    {
      name: 'Canvas Texture',
      image: '/assets/matte.jpg',
      description: 'Thick pages with a painterly texture, great for vintage-style books.'
    }
  ];   

  return (
    <div className="products-container">
      <h1>Our Photobooks</h1>
      <p className="intro">Explore a wide variety of beautifully bound, customizable photo books to fit every occasion.</p>

      <div className="product-grid">
        {products.map((product) => (
          <div className="product-card" key={product.id}>
            <img src={product.image} alt={product.title} />
            <h3>{product.title}</h3>
            <p>{product.description}</p>
            <Link to={`/products/${product.id}`} className="details-btn">
                 View Details
            </Link>
          </div>
        ))}
      </div>
      <Flipbook />

      <section className="sheet-types">
        <h2>Paper & Sheet Options</h2>
        <p>Choose from premium paper types to make your photobook truly yours.</p>
        <div className="sheet-grid">
          {sheetTypes.map((sheet, i) => (
            <div className="sheet-card" key={i}>
              {/* <img src={sheet.image} alt={sheet.name} /> */}
              <h4>{sheet.name}</h4>
              <p>{sheet.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="custom-options">
        <h2>Customization Possibilities</h2>
        <ul>
          <li>➤ Choose your cover material: leather, linen, photo wrap</li>
          <li>➤ Personalize titles and captions with your own text styles</li>
          <li>➤ Add clipart, icons, and frames to enhance your story</li>
          <li>➤ Select sizes from compact to premium landscape formats</li>
          <li>➤ Include dedication pages or table of contents</li>
        </ul>
      </section>

      <section className="products-cta">
        <h2>Need Help Choosing?</h2>
        <p>Contact our design team to guide you through your perfect photobook.</p>
        <a href="/contact#contact-form" className="primary-btn">Talk to Us</a>
      </section>
    </div>
  );
}
